<div class="scad-header">
    <div class="scad-header__wrapper">
      <div class="scad-header__row">
      <div class="scad-header__left-content">
        <div class="scad-header__profile-user"> 
          <img src="https://spruko.com/demo/sash/sash/assets/images/users/21.jpg" alt="" > 
        </div>

        <div class="scad-header__head-action"><img src="/assets/images/svg/notification.svg" alt=""></div>
        <div class="scad-header__head-action"><img src="/assets/images/svg/global.svg" alt=""></div>
        <div class="scad-header__head-action"><img src="/assets/images/svg/dark-mode.svg" alt=""></div>
        <div class="scad-header__head-action"> <img src="/assets/images/svg/person.svg" alt=""></div>

      </div>
      <div class="scad-header__center-content">
        <div class="scad-header__head-menu" routerLink="/home">Home Page</div>
        <div class="scad-header__head-menu">My Apps</div>
        <div class="scad-header__head-menu">Domains <span><img src="/assets/images/svg/down-arrow-1.svg" alt=""></span> </div>
        <div class="scad-header__head-menu scad-header__head-menu-active">FLOW BUILDER</div>
      </div>
      <div class="scad-header__right-content">
        <div ><img src="/assets/images/svg/logo.svg" alt="" height="35px"></div>
        <div class="right-border"></div>
        <div class="d-flex"><img src="/assets/images/svg/scad-white-logo.svg" height="60px" alt=""></div>
      </div>
      </div>
    </div>

    <div>
      <div>

        What data are you lookinf fir
      </div>
    </div>
</div>
